// Client mirror of auth/server/lib/euVat.js (source of truth).
import { isValidSiTaxNumber } from './kycValidators';

function checkDE(n) {
  if (!/^\d{9}$/.test(n)) return false;
  let product = 10;
  for (let i = 0; i < 8; i++) {
    let sum = (parseInt(n[i], 10) + product) % 10;
    if (sum === 0) sum = 10;
    product = (2 * sum) % 11;
  }
  const check = (11 - product) % 10;
  return check === parseInt(n[8], 10);
}

function checkAT(n) {
  if (!/^U\d{8}$/.test(n)) return false;
  const d = n.slice(1);
  const w = [1, 2, 1, 2, 1, 2, 1];
  let s = 0;
  for (let i = 0; i < 7; i++) {
    const p = parseInt(d[i], 10) * w[i];
    s += Math.floor(p / 10) + (p % 10);
  }
  const check = (10 - ((s + 4) % 10)) % 10;
  return check === parseInt(d[7], 10);
}

function checkIT(n) {
  if (!/^\d{11}$/.test(n)) return false;
  let sum = 0;
  for (let i = 0; i < 10; i++) {
    let d = parseInt(n[i], 10);
    if (i % 2 === 1) { d *= 2; if (d > 9) d -= 9; }
    sum += d;
  }
  const check = (10 - (sum % 10)) % 10;
  return check === parseInt(n[10], 10);
}

function checkSI(n) {
  return isValidSiTaxNumber(n);
}

const EU_VAT = {
  AT: { re: /^U\d{8}$/, check: checkAT },
  BE: { re: /^[01]\d{9}$/ },
  BG: { re: /^\d{9,10}$/ },
  CY: { re: /^\d{8}[A-Z]$/ },
  CZ: { re: /^\d{8,10}$/ },
  DE: { re: /^\d{9}$/, check: checkDE },
  DK: { re: /^\d{8}$/ },
  EE: { re: /^\d{9}$/ },
  EL: { re: /^\d{9}$/ },
  ES: { re: /^[A-Z0-9]\d{7}[A-Z0-9]$/ },
  FI: { re: /^\d{8}$/ },
  FR: { re: /^[A-Z0-9]{2}\d{9}$/ },
  HR: { re: /^\d{11}$/ },
  HU: { re: /^\d{8}$/ },
  IE: { re: /^(\d{7}[A-Z]{1,2}|\d[A-Z0-9*+]\d{5}[A-Z])$/ },
  IT: { re: /^\d{11}$/, check: checkIT },
  LT: { re: /^(\d{9}|\d{12})$/ },
  LU: { re: /^\d{8}$/ },
  LV: { re: /^\d{11}$/ },
  MT: { re: /^\d{8}$/ },
  NL: { re: /^\d{9}B\d{2}$/ },
  PL: { re: /^\d{10}$/ },
  PT: { re: /^\d{9}$/ },
  RO: { re: /^\d{2,10}$/ },
  SE: { re: /^\d{12}$/ },
  SI: { re: /^\d{8}$/, check: checkSI },
  SK: { re: /^\d{10}$/ },
  CH: { re: /^E\d{9}$/ },
  NO: { re: /^\d{9}$/ },
  IS: { re: /^\d{5,6}$/ },
  LI: { re: /^\d{5}$/ }
};

const PREFIXES = new Set(Object.keys(EU_VAT));

function toPrefix(iso2) {
  if (!iso2) return null;
  const up = String(iso2).toUpperCase();
  return up === 'GR' ? 'EL' : up;
}

export function isValidEuVat(value, countryHint) {
  if (!value) return false;
  const v = String(value).toUpperCase().replace(/[\s.\-]/g, '');

  let prefix = null;
  let body = v;
  const m = /^([A-Z]{2})(.+)$/.exec(v);
  if (m && PREFIXES.has(m[1])) {
    prefix = m[1];
    body = m[2];
  } else {
    prefix = toPrefix(countryHint);
  }

  const rule = prefix ? EU_VAT[prefix] : null;
  if (!rule) return /^[A-Z0-9 -]{4,32}$/.test(v);
  if (!rule.re.test(body)) return false;
  if (rule.check && !rule.check(body)) return false;
  return true;
}
